import TrendingTopicRow from "./TrendingTopicRow.style"

export default TrendingTopicRow
